import { render, staticRenderFns } from "./SupplierSizeTextInputOld.vue?vue&type=template&id=7cb019f2"
import script from "./SupplierSizeTextInputOld.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizeTextInputOld.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports